export default __webpack_public_path__ + "static/media/navBarLogo.cbb131a6.svg";